// import { epicsList } from '../../constants/epics.index'

import axiosNew from '../../../../helpers/axios'

// GET TEST CASE LIST
export const apiGetTestCaseList = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/testcase/list`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// CREATE TEST RUN
export const createTestRun = (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload ?? {}
            const createEpicData = await axiosNew({
                url: '/testcase-report/add',
                method: 'post',
                data,
            })
            resolve({ data: createEpicData?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
